import { apiSlice } from 'store/api/apiSlice';

export const checkoutAPISlice: any = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOrderBillingByOrderId: builder.query({
      query: ({ orderId, customerId, sendEvent = true }) => ({
        url: `/order/public/orderBilling?orderId=${orderId}&customerId=${customerId}&sendEvent=${sendEvent}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    createPaymentSession: builder.mutation({
      query: (orderDetailsBody) => ({
        url: '/order/payment/public/payment-session',
        method: 'POST',
        body: orderDetailsBody,
      }),
    }),
    getPaymentStatusByOrderId: builder.query({
      query: ({ orderId }) => ({
        url: `/order/payment/public/payment-status?orderId=${orderId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    saveBillingResponse: builder.mutation({
      query: ({ billDetailsBody }) => ({
        url: `/order/public/saveBillingResponse`,
        method: 'PUT',
        body: billDetailsBody,
      }),
    }),
    requestBill: builder.mutation({
      query: ({ orderId }) => ({
        url: `/order/public/update-order-request-bill?orderId=${orderId}&orderStatus=REQUEST_BILL`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useGetOrderBillingByOrderIdQuery,
  useCreatePaymentSessionMutation,
  useGetPaymentStatusByOrderIdQuery,
  useSaveBillingResponseMutation,
  useRequestBillMutation,
} = checkoutAPISlice;
